import { cn, Icon, Typography } from "@kyan/ui";
import React from "react";

import { TokenAmount } from "#/services/bridge/bridge.types";
import { formatValue } from "#/utils/valueFormatters";

import { ChainToken } from "../TokenSelector/components/ChainToken";

interface QuoteCardProps {
  input?: TokenAmount;
  output?: TokenAmount;
  variant?: "default" | "compact";
  isCompleted?: boolean;
}

export const QuoteCard: React.FC<QuoteCardProps> = ({
  output,
  input,
  variant = "default",
  isCompleted = false,
}) => {
  if (!output || !input) {
    return null;
  }
  const outputToken = output.token;
  const inputToken = input.token;

  return (
    <div
      className={cn("flex w-full items-center justify-between gap-1", {
        "border-divider rounded-md border p-6": variant === "default",
        "p-1": variant === "compact",
      })}
    >
      <div className="flex flex-col gap-2">
        <Typography xs>{isCompleted ? "You sent" : "You send"}</Typography>
        <div className="flex items-center gap-2">
          <ChainToken hideBalance token={inputToken} />
          <div className="flex flex-col gap-0.5">
            <Typography medium primary>
              {formatValue(BigInt(input.amount), {
                decimals: input.token.decimals,
                precision: 4,
                trailingZeroDisplay: "stripIfInteger",
              })}{" "}
              {inputToken.symbol}
            </Typography>
            <Typography xs>${input.valueInUsd}</Typography>
          </div>
        </div>
      </div>
      <Icon name="arrow-up" className="rotate-90" />
      <div className="flex flex-col gap-2">
        <Typography xs className="text-right">
          {isCompleted ? "You received" : "You receive"}
        </Typography>
        <div className="flex items-center justify-end gap-2">
          <div className="flex flex-col gap-0.5 text-right">
            <Typography medium primary>
              {formatValue(BigInt(output.amount), {
                decimals: outputToken.decimals,
                precision: 4,
                trailingZeroDisplay: "stripIfInteger",
              })}{" "}
              {outputToken.symbol}
            </Typography>
            <Typography xs>${output.valueInUsd}</Typography>
          </div>
          <ChainToken hideBalance direction="right" token={outputToken} />
        </div>
      </div>
    </div>
  );
};
